import { StopOutlined } from "@ant-design/icons";

import { RVConfirmationTriggerModalButton } from "@regal-voice/ui";

export function StopButton({
    disabled,
    stopPending,
    handleStop,
}: {
    disabled: boolean;
    stopPending: boolean;
    handleStop: () => Promise<void>;
}): JSX.Element {
    return (
        <RVConfirmationTriggerModalButton
            disabled={disabled}
            loading={stopPending}
            handleMethod={handleStop}
            danger={true}
            buttonText="Stop"
            title="Stop Journey?"
            content={
                <>
                    <span>
                        Stopping this journey will cause in-progress contacts to exit the journey and turn this journey
                        into a draft to prevent new entrances.
                    </span>
                    <br></br>
                    <br></br>
                    <span>
                        It may take up to 5 minutes to fully stop all in-progress contacts. During that time, you should
                        not turn the journey back to live.
                    </span>
                </>
            }
            confirmText="Yes, Stop Journey"
            okLoading="Stopping Journey"
            icon={<StopOutlined />}
        />
    );
}
